import { apiRequest } from './httpClient';

export async function getLeadFunnelReport({ days = 90 } = {}) {
  return apiRequest('getLeadFunnelReport', {
    method: 'POST',
    body: { days },
    requireAuth: true,
  });
}

// `dryRun` va en true por defecto en el backend: sin pasarlo explícitamente en
// false no se envía ningún correo.
export async function runInactiveLeadsNurture(options = {}) {
  return apiRequest('runInactiveLeadsNurture', {
    method: 'POST',
    body: options,
    requireAuth: true,
  });
}
